import { coreSyncSecurityAlertsPostSlice } from './post';

export const {
	requestPostCoreSyncSecurityAlerts,
	resetPostCoreSyncSecurityAlerts
} = coreSyncSecurityAlertsPostSlice.asyncActionCreators;
